import { render, staticRenderFns } from "./KondisiNonAktif.vue?vue&type=template&id=a52a3860&"
import script from "./KondisiNonAktif.vue?vue&type=script&lang=js&"
export * from "./KondisiNonAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports